<template>
  <div class="mb-12" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'">
    <v-dialog v-model="dialog.delete" persistent max-width="400">
      <v-card class="pa-3">
        <v-card-title class="title">Peringatan !</v-card-title>
        <v-card-text>Apakah anda yakin ingin menghapus data ini ?</v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            width="70"
            color="#ff618a"
            elevation="0"
            :disabled="process.form"
            :loading="process.form"
            class="white--text text-capitalize"
            @click="deletes">
            Yakin
          </v-btn>
          <v-btn
            rounded
            small
            width="70"
            elevation="0"
            class="text-capitalize"
            :disabled="process.form"
            @click="dialog.delete = false; form.aboutId = ''">
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.form" persistent max-width="400">
      <v-card class="pa-3">
        <div v-if="selectedPage === 'create' || selectedPage === 'update'">
          <div class="title text--secondary mb-5">
            {{ selectedPage === 'create' ? 'Tambah' : 'Ubah' }} Tentang Kami
          </div>
          <ValidationObserver ref="observer">
            <v-form>
              <quill-editor 
                ref="myTextEditorTitle" 
                v-model="form.aboutTitle" 
                :options="option">
              </quill-editor>
              <p
                class="caption mt-1 mb-1 red--text"
                v-show="error.aboutTitle">
                {{ error.aboutTitle }}
              </p>
              <ValidationProvider name="Status" rules="required" v-slot="{ errors }">
                <v-select
                  class="mt-5"
                  :items="[
                    {
                      title: 'Draft', 
                      value: 'draft'
                    },
                    {
                      title: 'Publish', 
                      value: 'publish'
                    }
                  ]"
                  item-text="title"
                  item-value="value"
                  dense
                  outlined
                  color="#ff618a"
                  label="Status"
                  v-model="form.aboutStatus"
                  :error-messages="errors"
                  require>
                </v-select>
              </ValidationProvider>
                <quill-editor 
                ref="myTextEditorDesc" 
                v-model="form.aboutDesc" 
                :options="option">
              </quill-editor>
              <p
                class="caption mt-1 mb-1 red--text"
                v-show="error.aboutDesc">
                {{ error.aboutDesc }}
              </p>
              <div class="mb-3">
                <p class="mb-1">Gambar (optional)</p>
                <form>
                  <v-card flat width="220" class="pa-0" style="background: transparent;">
                    <image-input v-model="avatar" type="uploadCover">
                      <div slot="activator">
                        <v-avatar tile size="100" height="100" class="grey lighten-3 cursor-pointer" v-ripple>
                          <v-icon v-if="!avatar && addImage === ''" color="grey darken-3" large>mdi-camera</v-icon>
                            <div class="px-5" v-if="addImage && avatar.url === undefined">
                            <v-progress-linear
                            color="#ff618a"
                            indeterminate
                            rounded
                            height="6"
                            class="mx-4 mt-4"
                            style="width: 80px;"
                            >
                            <p class="mt-2 mx-4 mb-0" style="font-size: 9px;">
                              Mengupload Gambar . . .
                            </p>
                            </v-progress-linear>
                          </div>
                          <img v-if="avatar && !addImage" :src="form.aboutLogo" :alt="form.aboutLogo"  width="200"
                            height="200"/>
                        </v-avatar>
                      </div>
                    </image-input>
                  </v-card>
                </form>
                <!-- <p
                  class="caption text-left mt-1 red--text"
                  v-show="error.aboutLogo">
                  {{ error.aboutLogo }}
                </p> -->
              </div>
              <div>
                <v-alert
                  type="error"
                  text
                  dense
                  prominent
                  v-show="response !== ''">
                  {{ response }}
                </v-alert>
              </div>
              <v-card-actions class="mt-2">
                <v-spacer></v-spacer>
                <v-btn
                  small
                  rounded
                  width="100"
                  color="#FF618A "
                  elevation="0"
                  :disabled="process.form"
                  :loading="process.form"
                  @click="save"
                  class="white--text text-capitalize">
                  Simpan
                </v-btn>
                <v-btn
                  rounded
                  small
                  width="100"
                  elevation="0"
                  class="text-capitalize"
                  :disabled="process.form"
                  @click="reset(undefined, 'mobile'); selectedPage = 'create'; $refs.observer.reset()">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </div>

        <div v-if="selectedPage === 'detail'">
          <div class="mt-4">
            <v-list-item-title
              class="body-2 grey--text text--darken-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Judul
              </p>
              <p class="body-2 grey--text text--darken-2"
                v-html="detail.title">
              </p>
            </v-list-item-title>
            <v-list-item-title
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Status
              </p>
              {{detail.status}}
            </v-list-item-title>
            <p class="caption grey--text text-lighten-4 mt-3 mb-1">
              Deskripsi
            </p>
            <p class="body-2 grey--text text--darken-2"
              v-html="detail.description">
            </p>
          </div>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn
              rounded
              small
              width="100"
              elevation="0"
              class="text-capitalize"
              @click="reset(undefined, 'mobile'); selectedPage = 'create'">
              Tutup
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" :sm="showPage === false ? '12' : '8'">
        <div :class="$vuetify.breakpoint.name !== 'xs' ? 'd-flex' : ''">
          <v-text-field
            filled
            rounded
            dense
            :hide-details="true"
            placeholder="Cari tentang kami . . ."
            v-model="filter.title"
            clearable
            color="#ff618a"
            @click:clear="filter.title = ''; fetch();showPage = false"
            v-on:keyup.enter="fetch();showPage = false"
            prepend-inner-icon="mdi-magnify">
          </v-text-field>
          <v-btn
            :color="!showPage ? '#ff618a' : '#F5F5F5'"
            :width="$vuetify.breakpoint.name === 'xs' ? '100%' : '200'"
            class="text-capitalize"
            :class="$vuetify.breakpoint.name === 'xs' ? 'mt-3' : 'mx-3'"
            :dark="!showPage"
            elevation="0"
            rounded
            :disabled="process.form"
            :light="showPage"
            v-on:click="$vuetify.breakpoint.name === 'xs' ? reset(undefined, 'mobile') : $vuetify.breakpoint.name === 'sm' ? reset(undefined, 'mobile') : reset()"
            @click="selectedPage = 'create';">
            <span v-if="!showPage">Tambah Tentang Kami</span>
            <span v-if="showPage">Kembali</span>
          </v-btn>
        </div>
        <div class="my-5">
          <div class="title text--secondary">Data Tentang Kami</div>
          <div class="caption text--secondary">{{pagination.totalData}} Tentang Kami Ditemukan</div>
          <v-skeleton-loader
            class="ma-auto"
            :loading="process.run"
            transition="scale-transition"
            :tile="false"
            type="list-item-avatar-two-line"
            v-for="(l, index) in process.run ? 10:list"
            :key="index">
            <v-list dense class="line my-3 mr-5">
              <v-list-item>
                <v-list-item-avatar tile @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer mr-3">
                  <v-icon>mdi-information-outline</v-icon>
                </v-list-item-avatar>
                <v-list-item-content @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer">
                  <v-list-item-title
                    class="body-2 font-weight-bold grey--text text--darken-2"
                    v-html="l.title">
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="$vuetify.breakpoint.name !== 'xs'"
                    class="caption mt-1 grey--text text--darken-2 text-capitalize font-weight-thin">
                    {{l.status}}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content class="ml-3 text-right">
                  <div>
                    <v-btn
                      fab
                      x-small
                      :disabled="process.form"
                      color="#269B91"
                      elevation="0"
                      class="text-capitalize white--text ma-1"
                      v-on:click="$vuetify.breakpoint.name === 'xs' ? reset(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? reset(l, 'mobile') : reset(l)"
                      @click="selectedPage = 'update'">
                      <v-icon small>mdi-square-edit-outline</v-icon>
                    </v-btn>
                    <v-btn 
                      fab
                      x-small
                      color="red"
                      elevation="0"
                      class="text-capitalize white--text ma-1"
                      :disabled="process.form"
                      @click="form.aboutId = l.id; dialog.delete = true">
                      <v-icon small>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-skeleton-loader>
          <Empty v-show="!process.run && list.length < 1" content="Data Tentang Kami"/>
          <div v-if="pagination.totalPage > 1">
            <v-row>
              <v-col cols="5">
                <div class="body-2 font-weight-bold mt-4">Total {{ pagination.totalData }} data</div>
              </v-col>
              <v-col cols="7">
                <div class="float-right">
                  <v-pagination
                    v-model="page"
                    :length="pagination.totalPage"
                    :total-visible="5"
                    color="#FF618A"
                    @input="fetch(page);showPage = false"
                    circle>
                  </v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>

      <v-col cols="12" sm="4" class="mt-3 background-default pa-7" v-if="showPage  && $vuetify.breakpoint.name !== 'xs'">
        <div v-if="selectedPage === 'create' || selectedPage === 'update'">
          <div class="title text--secondary mb-5">
            {{ selectedPage === 'create' ? 'Tambah' : 'Ubah' }} Tentang Kami
          </div>
          <ValidationObserver ref="observer">
            <v-form>
              <p class="mb-1">
                Judul
              </p>
              <quill-editor 
                ref="myTextEditorTitle" 
                v-model="form.aboutTitle" 
                :options="option">
              </quill-editor>
              <p
                class="caption mt-1 mb-1 red--text"
                v-show="error.aboutTitle">
                {{ error.aboutTitle }}
              </p>
              
              <p class="mb-1 mt-2">
                Deskripsi
              </p>
              <quill-editor 
                ref="myTextEditorDesc" 
                v-model="form.aboutDesc" 
                :options="option">
              </quill-editor>
              <p
                class="caption mt-1 mb-1 red--text"
                v-show="error.aboutDesc">
                {{ error.aboutDesc }}
              </p>
              <ValidationProvider name="Status" rules="required" v-slot="{ errors }">
                <v-select
                  class="mt-5"
                  :items="[
                    {
                      title: 'Draft', 
                      value: 'draft'
                    },
                    {
                      title: 'Publish', 
                      value: 'publish'
                    }
                  ]"
                  item-text="title"
                  item-value="value"
                  dense
                  outlined
                  color="#ff618a"
                  label="Status"
                  v-model="form.aboutStatus"
                  :error-messages="errors"
                  require>
                </v-select>
              </ValidationProvider>
              <div class="mb-3">
                <p class="mb-1">Gambar (optional)</p>
                <form>
                  <v-card flat width="220" class="pa-0" style="background: transparent;">
                    <image-input v-model="avatar" type="uploadCover">
                      <div slot="activator">
                        <v-avatar tile size="100" height="100" class="grey lighten-3 cursor-pointer" v-ripple>
                          <v-icon v-if="!avatar && addImage === ''" color="grey darken-3" large>mdi-camera</v-icon>
                            <div class="px-5" v-if="addImage && avatar.url === undefined">
                            <v-progress-linear
                            color="#ff618a"
                            indeterminate
                            rounded
                            height="6"
                            class="mx-4 mt-4"
                            style="width: 80px;"
                            >
                            <p class="mt-2 mx-4 mb-0" style="font-size: 9px;">
                              Mengupload Gambar . . .
                            </p>
                            </v-progress-linear>
                          </div>
                          <img v-if="avatar && !addImage" :src="form.aboutLogo" :alt="form.aboutLogo"  width="200"
                            height="200"/>
                        </v-avatar>
                      </div>
                    </image-input>
                  </v-card>
                </form>
                <!-- <p
                  class="caption text-left mt-1 red--text"
                  v-show="error.aboutLogo">
                  {{ error.aboutLogo }}
                </p> -->
              </div>
              <div>
                <v-alert type="error" text dense prominent v-show="response !== ''">
                  {{ response }}
                </v-alert>
              </div>
              <v-card-actions class="mt-5">
                <v-spacer></v-spacer>
                <v-btn
                  dense
                  rounded
                  width="200"
                  color="#FF618A"
                  elevation="0"
                  :disabled="process.form"
                  :loading="process.form"
                  @click="save"
                  class="white--text text-capitalize">
                  Simpan
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </div>

        <div v-if="selectedPage === 'detail'">
          <div class="mt-4">
            <v-list-item-title
              class="body-2 grey--text text--darken-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Judul
              </p>
              <p class="body-2 grey--text text--darken-2"
                v-html="detail.title">
              </p>
            </v-list-item-title>
            <v-list-item-title
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Status
              </p>
              {{detail.status}}
            </v-list-item-title>
            <p class="caption grey--text text-lighten-4 mt-2 mb-1">
              Deskripsi
            </p>
            <p class="body-2 grey--text text--darken-2"
              v-html="detail.description">
            </p>
            <v-list-item-title
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
               Gambar
              </p>
             <v-img 
                width="150" 
                height="150"
                :src="detail.urlCover"
                class="br-20 cursor-pointer">
              </v-img>
            </v-list-item-title>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../../service/Axios";
  import Empty from "../../../../components/DataEmpty";
  import ImageInput from "../../../../components/ImageInput.vue";
  export default {
    data() {
      return {
        option: {
          modules: {
            toolbar: [
              ["bold", "italic", "underline"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ color: [] }, { background: [] }],
              [{ align: [] }]
            ]
          },
          placeholder: 'Deskripsi . . .'
        },
        dialog: {
          delete: false,
          form: false
        },
        page:1,
        showPage: false,
        selectedPage: "",
        filter: {
          title: ""
        },
        detail: {},
        list: [],
        pagination: {},
        page: 1,
        section: {
          home : [
            {
              title : "",
              desc : "",
              image:""
            },
            {
              title : "",
              desc : "",
              image:""
            },
            {
              title : "",
              desc : "",
              image:""
            },
            {
              title : "",
              desc : "",
              image:""
            }
          ],
        },
        addImage:'',
        avatar:"",
        form: {
          aboutId: "",
          aboutTitle: "",
          aboutDesc: "",
          aboutStatus: "",
          aboutLogo: "",
        },
        error: {
          aboutTitle: "",
          aboutDesc: "",
          aboutLogo: ""
        },
        process: {
          form: false,
          run: false
        },
        response: ""
      };
    },
    watch: {
      avatar: {
        handler: function () {
          this.form.aboutLogo = this.avatar ? this.avatar.url : ""
          this.addImage = this.avatar.add
          this.error.aboutLogo = ''
        },
        deep: true
      }
    },
    components: {
      Empty,
      ImageInput
    },
    computed: {},
    mounted() {
      window.scrollTo(0, 0);
      this.fetch();
    },
    methods: {
      async fetch(p) {
        if (p === undefined) {
          this.page = 1
        }
        this.process.run = true
        await get(`api/internal/about/list`, {
            params: {
              pagenum: p,
              limit: 10,
              title: this.filter.title
            }
          })
        .then(response => {
          let res = response.data;
          if (res.code === 200) {
            this.process.run = false;
            for (let i in res.data) {
              res.data[i].title = res.data[i].title.replace(/&lt;/g, "<")
              res.data[i].description = res.data[i].description.replace(/&lt;/g, "<")
            }
            this.list = res.data;
            this.pagination = res.pagination;
          }
        });
      },
      toDetail(item, status) {
        this.detail = item;
        this.selectedPage = "detail";
        this.showPage = status !== undefined ? false : true
        this.dialog.form = status !== undefined ? true : false
      },
      reset(item, status) {
        this.showPage = status !== undefined ? false : !this.showPage ? true : false

        this.avatar = item !== undefined ? {
          url: item.urlCover
        } : ''

        this.form = {
          aboutId: item !== undefined ? item.id : "",
          aboutTitle : item !== undefined ? item.title : "",
          aboutDesc : item !== undefined ? item.description : "",
          aboutStatus : item !== undefined ? item.status : "",
          aboutLogo : item !== undefined ? item.urlCover : ""
        }

        this.selectedPage = ''
        this.process.form = false

        this.error = {
          aboutTitle: "",
          aboutDesc: ""
        }
        this.dialog.form = status !== undefined ? !this.dialog.form ? true : false : false
        this.response = ''
      },
      validation() {
        var error = this.error,
          valid = true
        
        if (this.form.aboutTitle === "") {
          error.aboutTitle = "Kolom tidak boleh kosong"
          valid = false
        } else {
          error.aboutTitle = ""
        }

        // if (this.form.aboutLogo === "") {
        //   error.aboutLogo = "Gambar tidak boleh kosong";
        //   valid = false;
        // } else {
        //   error.aboutLogo = "";
        // }

        if (this.form.aboutDesc === "") {
          error.aboutDesc = "Kolom tidak boleh kosong"
          valid = false
        } else {
          error.aboutDesc = ""
        }
        
        return valid;
      },
      async save() {
        this.response = ""
        const valids = this.validation()
        const isValid = await this.$refs.observer.validate()
        if (isValid & valids) {
          if (this.form.aboutId === "") {
            this.creates()
          } else {
            this.updates()
          }
        }
      },
      async creates() {
        this.process.form = true
        await post(`api/internal/about/create`, {
          data: {
            title: this.form.aboutTitle,
            description: this.form.aboutDesc,
            status: this.form.aboutStatus,
            urlCover: this.form.aboutLogo
          }
        }).then(response => {
          let res = response.data
          if (res.code === 201) {
            this.fetch()
            if (this.dialog.form === true) {
              this.reset(undefined, 'mobile')
            } else {
              this.reset();
            }
          } else {
            this.process.form = false
            this.response = res.msg
          }
        })
      },
      async updates() {
        this.process.form = true
        await put(`api/internal/about/update/${this.form.aboutId}`, {
          data: {
            id: this.form.aboutId,
            title: this.form.aboutTitle,
            description: this.form.aboutDesc,
            status: this.form.aboutStatus,
            urlCover: this.form.aboutLogo
          }
        }).then(response => {
          let res = response.data
          if (res.code === 201) {
            this.fetch(this.page);
            if (this.dialog.form === true) {
              this.reset(undefined, 'mobile')
            } else {
              this.reset();
            }
          } else {
            this.process.form = false
            this.response = res.msg
          }
        })
      },
      async deletes() {
        this.process.form = true;
        await destroy(`api/internal/about/delete/${this.form.aboutId}`)
        .then((response) => {
          let res = response.data;
          if (res.code === 201) {
            this.process.form = false
            this.dialog.delete = false
            this.showPage = false
            this.form.aboutId = ''
            this.fetch()
          } else {
            this.process.form = false
            this.response = res.msg
          }
        })
      }
    }
  }
</script>
